import { render, staticRenderFns } from "./dianka.vue?vue&type=template&id=5979fa3f"
import script from "./dianka.vue?vue&type=script&lang=js"
export * from "./dianka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports